import {
  AlertStatus,
  useAlertStyles,
} from '@chakra-ui/react';

import { ErrorIcon } from './ErrorIcon';
import { InfoIcon } from './InfoIcon';
import { SuccessIcon } from './SuccessIcon';
import { VisaIcon } from './VisaIcon';
import { TimeIcon } from './TimeIcon';
import { OxxoIcon } from './OxxoIcon';


type AlertIconStatus = AlertStatus | 'visa' | 'oxxo';

const IconStatus = {
  oxxo: OxxoIcon,
  visa: VisaIcon,
  info: InfoIcon,
  warning: ErrorIcon,
  success: SuccessIcon,
  loading: TimeIcon,
  error: ErrorIcon,
};

const getStatusIcon = (status: AlertIconStatus) => IconStatus[status];

export const AlertIcon = ({ status }: { status: AlertIconStatus }) => {
  const BaseIcon = getStatusIcon(status);
  const styles = useAlertStyles();
  return <BaseIcon __css={styles.icon} />;
};

